import { render } from "./cover-layer.vue?vue&type=template&id=b9aa592e"
import script from "./cover-layer.vue?vue&type=script&lang=js"
export * from "./cover-layer.vue?vue&type=script&lang=js"

import "./cover-layer.vue?vue&type=style&index=0&id=b9aa592e&lang=less"

import exportComponent from "/Users/liuyansong/Work/Vue/test/vue3-video-player/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__